/**
 * Helpers para saber si un usuario ya vio los videos tutoriales asociados
 * a cada quiz. El estado se persiste por usuario en localStorage bajo la
 * llave `tutorial_visto_<userId>_<tipo>_<kind>`.
 *
 * `tipo` corresponde a los valores de MediaTutorial.TIPO_CHOICES del backend:
 *   - inicio_quiz
 *   - inicio_confirmacion
 *   - inicio_fortaleza
 *   - inicio_aplicacion
 *
 * `kind` es "tutorial" o "instrucciones".
 */

const buildKey = (userId, tipo, kind) =>
  `tutorial_visto_${userId || "anon"}_${tipo}_${kind}`;

export const marcarTutorialVisto = (userId, tipo, kind) => {
  try {
    localStorage.setItem(buildKey(userId, tipo, kind), "true");
  } catch {
    // Ignorar si localStorage no está disponible.
  }
};

export const isTutorialVisto = (userId, tipo, kind) => {
  try {
    return localStorage.getItem(buildKey(userId, tipo, kind)) === "true";
  } catch {
    return false;
  }
};

/**
 * Devuelve true si todos los kinds pasados han sido vistos.
 */
export const todosTutorialesVistos = (userId, tipo, kinds) => {
  if (!kinds || kinds.length === 0) return true;
  return kinds.every((k) => isTutorialVisto(userId, tipo, k));
};
